import { BodyText, Flex, Switch } from '@utilitywarehouse/hearth-react';

import { useCashbackCalculatorContext } from '../CalculatorProvider/CalculatorContext';

const IncludeCashbackSwitch = () => {
  const { useCashbackValueInComms, setUseCashbackValueInComms } =
    useCashbackCalculatorContext();

  return (
    <Flex spacing="md">
      <Switch
        disabled={false}
        checked={useCashbackValueInComms}
        onCheckedChange={setUseCashbackValueInComms}
        size="sm"
        id="include-cashback-earnings"
      />
      <BodyText as="label" htmlFor="include-cashback-earnings">
        Include est. cashback earnings in my bundle
      </BodyText>
    </Flex>
  );
};

export { IncludeCashbackSwitch };
